import type { TimeRange } from '@/shared/charts/time-series-chart/TimeSeriesChart.types';

import type { TimeDomain } from '../types/TimeDomain.types';

export function toTimeDomain({ startTimestamp, endTimestamp }: TimeRange): TimeDomain {
  return [startTimestamp, endTimestamp];
}
